import { NOTIFICATION_CHANNELS } from '@/utils/okr-elements/notifications'

export const ALERTS_LIMIT = 50
export const ALERT_NAME_MAX_LENGTH = 63

export const ALERTS_TYPES = {
  CHECKIN_CREATED: 1
}

export const ALERTS_EXCLUDED_CHANNELS = [
  NOTIFICATION_CHANNELS.INBOX.typeId,
  NOTIFICATION_CHANNELS.EMAIL.typeId
]

export const FALLBACK_ALERT_DISPLAY_NAME = 'Untitled automation'
